import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { LONG_DASH } from '@dealstack/frontend/shared/other/react/specialSigns';
import { Text } from '@mantine/core';
import { memo, useEffect, useRef, useState } from 'react';

interface Props {
	instruction?: string | null;
	onClick?: () => void;
}

const TableInstructionsText = ({ instruction, onClick }: Props) => {
	const tInvestor = useTranslationInvestor();
	const ref = useRef<HTMLDivElement | null>(null);
	const [isTruncated, setIsTruncated] = useState(true);

	useEffect(() => {
		if (!ref?.current) {
			return;
		}
		setIsTruncated(ref.current.scrollHeight > ref.current.clientHeight);
	}, [ref]);

	return (
		<div>
			<Text ref={ref} lineClamp={4} fz="md">
				{instruction || LONG_DASH}
			</Text>
			{isTruncated && (
				<Text fz="sm" onClick={onClick} fw={600} c="blue.6" sx={{ cursor: 'pointer' }}>
					{tInvestor('investment.join.contracts.wet_inc_modal.view_instructions')}
				</Text>
			)}
		</div>
	);
};
const _TableInstructionsTextExport = memo(TableInstructionsText);

export { _TableInstructionsTextExport as TableInstructionsText };
